import React, { useState } from 'react'
import { ScrollView, Text, View } from 'react-native'
import { AppModal } from '../ui/AppModal'
import { Button } from '../ui/Button'
import { HelpButton } from '../ui/HelpButton'

export function BlockingHelp() {
  const [visible, setVisible] = useState(false)
  return <>
    <HelpButton accessibilityLabel="How blocking works" onPress={() => setVisible(true)} />
    <AppModal visible={visible} transparent animationType="fade" onRequestClose={() => setVisible(false)}>
      <View className="flex-1 items-center justify-center bg-black/60 p-6">
        <View className="bg-paper border-2 border-olive rounded-2xl p-5 gap-4 w-full" style={{ maxWidth: 480, maxHeight: '90%' }} accessibilityViewIsModal>
          <Text className="font-stencil text-ink text-xl" accessibilityRole="header">How blocking works</Text>
          <ScrollView>
            <Text className="font-typed text-ink text-base">Blocked players cannot send you direct messages or invites, or find you in game-invite searches.</Text>
            <Text className="font-typed text-ink text-base mt-3">Existing games, shared chat and message history stay unchanged.</Text>
          </ScrollView>
          <Button title="Got it" onPress={() => setVisible(false)} />
        </View>
      </View>
    </AppModal>
  </>
}
